import { ShieldCheck } from "lucide-react";
import TierBadge from "@/components/TierBadge";

export default function PassportCard({ user, score }) {
  const issued = new Date(user?.created_at || Date.now()).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
  return (
    <div
      className="relative bg-ec-soft border border-ec-ink/15 rounded-sm shadow-[inset_0_0_30px_rgba(0,0,0,0.03)] noise-overlay overflow-hidden"
      data-testid="passport-card"
    >
      {/* Watermark */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.04] text-[120px] font-display font-black flex items-center justify-center select-none">
        ETHICCRED
      </div>

      <div className="relative p-8 sm:p-10">
        <div className="flex justify-between items-start">
          <div>
            <div className="flex items-center gap-2 text-ec-ink">
              <div className="w-7 h-7 bg-ec-ink text-white flex items-center justify-center">
                <ShieldCheck className="w-3.5 h-3.5" />
              </div>
              <span className="eyebrow text-ec-ink">Professional Passport</span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl font-black mt-3" data-testid="passport-name">
              {user?.full_name}
            </h2>
            <p className="text-ec-ink-soft text-sm mt-1">{user?.headline || "Add a headline to your passport"}</p>
          </div>
          <div className="text-right">
            <div className="eyebrow">EthicCred ID</div>
            <div className="font-mono-plex text-lg font-bold mt-1 tracking-wider" data-testid="passport-ethic-id">
              {user?.ethic_id}
            </div>
            {score && (
              <div className="mt-3 flex items-center justify-end gap-2">
                <span className="font-display text-2xl font-black tracking-tighter">{score.score}</span>
                <TierBadge tier={score.tier} size="sm" />
              </div>
            )}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-3 gap-6 border-t border-dashed border-ec-ink/15 pt-6">
          <Field label="Role" value={user?.role?.replace("_", " ")} />
          <Field label="Location" value={user?.location || "—"} />
          <Field label="Issued" value={issued} />
        </div>

        <div className="absolute right-8 bottom-8 stamp text-ec-emerald">Verified</div>
      </div>
    </div>
  );
}

function Field({ label, value }) {
  return (
    <div>
      <div className="eyebrow">{label}</div>
      <div className="font-display text-base font-semibold mt-1 capitalize">{value || "—"}</div>
    </div>
  );
}
